<div class="flex flex-col" style="height:100vh; overflow:hidden;">

	<!-- Header -->
	<app-header />

	<!-- Marble border strip -->
	<div style="height: 15px; background-image: url('/images/marbleBorder.png'); background-repeat: repeat-x; background-size: auto 100%; flex-shrink: 0;"></div>

	<!-- Body: sidebar + content -->
	<div class="flex flex-1" style="min-height: 0;">

		<!-- Sidebar -->
		<div [style.width]="sidebarCollapsed ? '48px' : '96px'"
			style="flex-shrink: 0; transition: width 0.2s ease; border-right: 2px solid var(--color-gold-600); display: flex; flex-direction: column;">
			<app-sidebar
				[collapsed]="sidebarCollapsed"
				(collapsedChange)="onSidebarCollapse($event)" />
		</div>

		<!-- Content area -->
		<main class="flex-1" style="position:relative; overflow:hidden; background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">
			<div style="position:absolute; inset:0; overflow-y:auto; display:flex; flex-direction:column; align-items:stretch;">
				<router-outlet />
			</div>
		</main>

	</div>

	<!-- Marble border strip -->
	<div style="height: 15px; background-image: url('/images/marbleBorder.png'); background-repeat: repeat-x; background-size: auto 100%; flex-shrink: 0;"></div>

	<!-- Footer -->
	<app-footer />

</div>
